import { createAsyncThunk } from "@reduxjs/toolkit";
import { getProducts } from "../../services/products";

// Thunk for fetching Product list
export const fetchProductsList = createAsyncThunk(
  "sales/fetchProductsList",
  async (query, { rejectWithValue }) => {
    try {
      const response = await getProducts(query); 
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
